import { SVG } from '../SVG'

const CirclePlusIcon = ({ color = 'var(--primary-color)', style = {}, ...props }) => (
  <SVG
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: color, ...style }}
    {...props}
  >
    <path d='M25.5 13C25.5 19.875 19.875 25.5 13 25.5C6.125 25.5 0.5 19.875 0.5 13C0.5 6.125 6.125 0.5 13 0.5C19.875 0.5 25.5 6.125 25.5 13ZM19.25 11.75H14.25V6.75C14.25 6 13.75 5.5 13 5.5C12.25 5.5 11.75 6 11.75 6.75V11.75H6.75C6 11.75 5.5 12.25 5.5 13C5.5 13.75 6 14.25 6.75 14.25H11.75V19.25C11.75 20 12.25 20.5 13 20.5C13.75 20.5 14.25 20 14.25 19.25V14.25H19.25C20 14.25 20.5 13.75 20.5 13C20.5 12.25 20 11.75 19.25 11.75Z' />
  </SVG>
)

export default CirclePlusIcon
